var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ImageWrapper',{attrs:{"imagePath":"assets/images/Teaser_Password","imageName":"Teaser_Password","breakpoints":[300, 300, 353, 353, 353]}})
}
var staticRenderFns = []

export { render, staticRenderFns }